import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {loadDriverRuns} from '../../actions/runActions';
import Runs from  '../Runs/Runs';
import {
  IsInRole,
  ROLE_NewUser,
  URL_NewUser,
  ROLE_Driver,
  ROLE_LocationUser,
  ROLE_ClientUser,
  URL_NewClientLocation,
  Aux,
  GetUserLocation
} from "../../constants";
import { push } from '../../utils/navigation';
import UserClientLocationControl from '../Users/UserClientLocationControl';
import UserAuthenticationRequestsControl from '../Users/UserAuthenticationRequestsControl';
import DriverRunsView from "../DriverRuns/DriverRunsView";
import ClientHome from './ClientHome';

class HomePage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      userName: props.account.user.userName,
    };
    this.loadRuns = this.loadRuns.bind(this);
    this.userLocationsRef = React.createRef();
  }

  loadRuns() {
    this.props.dispatch(loadDriverRuns());
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    let {account} = this.props;

    if (account && account.user && account.user.userName !== this.state.userName) {
      window.scrollTo(0, 0);
      this.setState({userName: account.user.userName}, () => {
        this.loadRuns();
      });
    }
  }

  componentDidMount(){
    if(IsInRole(this.props.account, ROLE_NewUser)) {
      this.props.dispatch(push(URL_NewUser));
    }
    window.scrollTo(0, 0);
  }  

  render() {
    const {userLocation, account} = this.props;
    const {latitude, longitude, hasUserLocation} = GetUserLocation(userLocation);
    const isClient = account && account.user && account.user.hasRole(ROLE_ClientUser);
    const isLocationUser = account && account.user && account.user.hasRole(ROLE_LocationUser);
    return (
      <div>
        {this.props.account.user.userName==='' &&
        (<div>
          <div className="row">
            <div className="col-6 col-md-12">
              <p>Logging in, you will be redirected shortly... <i className="fa fa-cog fa-spin fa-2x" /></p>
            </div>
          </div>
        </div>)}
        {IsInRole(this.props.account, ROLE_Driver) &&
            <Aux>

              <div className={"mb-1"}>
                {hasUserLocation ?
                    <div className={"row"}>
                      <div className={"col-12 text-success"}>
                        <b>Current device location</b>&nbsp;&nbsp;<a href={`http://maps.google.com/maps?&z=21&q=${latitude}+${longitude}`}
                                                                     target={'_blank'}>{`${latitude}, ${longitude}`}</a>
                      </div>
                    </div>
                    :
                    <div className={"row"}>
                      <div className={"col-12 text-danger"}>
                        Device location not on!
                      </div>
                    </div>
                }
              </div>
              
              <DriverRunsView
                  runs={this.props.driverRuns}
                  loadRuns={this.loadRuns}
                  userName={this.props.account.user.userName}
              />

            </Aux>
        }

        {(IsInRole(this.props.account, ROLE_NewUser)) && !isClient && !isLocationUser 
        && <UserAuthenticationRequestsControl
          userId={this.props.account.user.id}
          account={this.props.account}
          requestsUpdated={() => this.userLocationsRef.current.loadCurrentUserLocations()}
          onCreateNewClient={() => this.props.dispatch(push(URL_NewClientLocation))}
          showUserPhoneWarning={true}
        />}

        <div className={'row'}>
          <div className={'col-6 col-md-12'}>&nbsp;</div>
        </div>

        {this.props.account && !isClient && !isLocationUser && <UserClientLocationControl
          onSelect={(x) => this.props.dispatch(push(x))}
          user={this.props.account.user}
          ref={this.userLocationsRef}
        />}

        {
            (isClient || isLocationUser) &&  <ClientHome />
        }

    </div>);
  }
}

HomePage.propTypes = {
  account: PropTypes.object.isRequired,
  driverRuns: PropTypes.object.isRequired
};

function mapStateToProps(state){
  return {
    account: state.account,
    driverRuns: state.driverRuns,
    userLocation: state.location,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
